<template>
    <div class="relative">
        <div class="px-10 py-4 flex items-center justify-center games-hedef-sayi-bulalim-rounded-gridant rounded-full border-2 games-hedef-sayi-bulalim-border-color-secondery">
            <slot></slot>
        </div>
    </div>
</template>
